import React, { useState, useEffect, useRef } from 'react';
import { Plus, LogOut } from 'lucide-react';;
import { logout } from '../services/authService';
import logo from '../assets/nexora-logo.png';
import { User } from 'firebase/auth';
import { translations } from '../locales/translations';

interface HeaderProps {
  onNewPrompt?: () => void;
  onLogout?: () => void;
  profileOpen: boolean;

setProfileOpen: React.Dispatch<
  React.SetStateAction<boolean>
>;

settingsOpen: boolean;

setSettingsOpen: React.Dispatch<
  React.SetStateAction<boolean>
>;
  showNewButton?: boolean;
  showLogout?: boolean;
  userEmail?: string;
  user?: User;
  openProfileExternal?: boolean;
  openSettingsExternal?: boolean;
  
}

const Header: React.FC<HeaderProps> = ({
  onNewPrompt,
  onLogout,

  profileOpen,
  setProfileOpen,

  settingsOpen,
  setSettingsOpen,

  showNewButton = true,
  showLogout = true,
  user,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hideSensitive, setHideSensitive] = useState(() => {
  return localStorage.getItem('hideSensitive') === 'true';
});
const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'pt';
});

const [isMobile, setIsMobile] =
  useState(false);

const t =
  translations[language as keyof typeof translations];
const toggleSensitiveContent = () => {
  
  const newValue = !hideSensitive;

  console.log(newValue);

  setHideSensitive(newValue);

  localStorage.setItem(
    'hideSensitive',
    String(newValue)
  );

  window.dispatchEvent(
    new Event('sensitive-content-change')
  );
};
const handleLanguageChange = (
  e: React.ChangeEvent<HTMLSelectElement>
) => {
  const newLanguage = e.target.value;

  setLanguage(newLanguage);

  localStorage.setItem(
    'language',
    newLanguage
  );

  window.dispatchEvent(
    new Event('language-change')
  );
};
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target as Node)
    ) {
      setMenuOpen(false);
    }
  };
 
  document.addEventListener('mousedown', handleClickOutside);

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
  
}, []);

useEffect(() => {

  const checkMobile = () => {

    setIsMobile(
      window.innerWidth < 768
    );

  };

  checkMobile();

  window.addEventListener(
    'resize',
    checkMobile
  );


  return () => {

    window.removeEventListener(
      'resize',
      checkMobile
    );

  };

}, []);

  return (
    
      <>
    <header className="sticky top-0 z-50 bg-dark-800/95 backdrop-blur border-b border-dark-700">
      <div className="w-full px-1.5 sm:px-4 lg:px-8">
        <div className="flex justify-between items-center h-14">
          <div className="flex items-center gap-3">
            <img
  src={logo}
  alt="Nexora"
  className="h-32 object-contain"
/>
          </div>

          <div className="flex items-center gap-3">
            {showNewButton && onNewPrompt &&  isMobile &&(

  <button
    onClick={onNewPrompt}

    className={`

      flex items-center justify-center
      transition-all

      ${isMobile
        ? `
          w-11
          h-11
          rounded-xl
          bg-purple-600
          hover:bg-purple-500
          shadow-lg
        `
        : `
          btn-primary
        `
      }

    `}
  >

    <Plus
      size={isMobile ? 22 : 18}
      className={!isMobile ? 'mr-2' : ''}
    />

    {!isMobile && t.addPrompt}

  </button>

)}
{user && !isMobile && (

  <div
    ref={menuRef}
    className="relative"
  >

    <button
      onClick={() =>
        setMenuOpen(!menuOpen)
      }
      className="relative flex items-center gap-3 px-3 py-2 rounded-xl bg-transparent hover:bg-dark-600 transition-all"
    >

      <img
        src={
          user?.photoURL ||
          'https://ui-avatars.com/api/?name=User&background=7C3AED&color=fff'
        }
        alt="User"
        className="w-10 h-10 rounded-full object-cover"
      />

      <div className="flex flex-col leading-tight">

        <span className="text-sm font-medium text-white">
          {user.displayName || 'Usuário'}
        </span>

        <span className="text-xs text-dark-300">
          {user.email}
        </span>

      </div>

    </button>

    {menuOpen && (
      <div className="absolute top-16 right-0 w-56 bg-dark-800 border border-dark-700 rounded-xl shadow-2xl p-2 z-50">

        <>
  <button
    onClick={() => {
      setProfileOpen(true);
      setMenuOpen(false);
    }}
    className="w-full text-left px-4 py-3 rounded-lg hover:bg-dark-700 text-dark-100 transition-all"
  >
    {t.profile}
  </button>

  <button
    onClick={() => {
      setSettingsOpen(true);
      setMenuOpen(false);
    }}
    className="w-full text-left px-4 py-3 rounded-lg hover:bg-dark-700 text-dark-100 transition-all"
  >
    {t.settings}
  </button>

  <button
    onClick={() => {
      setSettingsOpen(true);
      setMenuOpen(false);
    }}
    className="w-full text-left px-4 py-3 rounded-lg hover:bg-dark-700 text-dark-100 transition-all"
  >
    {t.language}
  </button>

  <div className="h-px bg-dark-700 my-2" />

  <button
    onClick={async () => {
      await logout();
    }}
    className="w-full text-left px-4 py-3 rounded-lg hover:bg-red-500/10 text-red-400 transition-all"
  >
    {t.logout}
  </button>
</>

      </div>
    )}

  </div>

)}
            {showLogout && onLogout && (
              <button
                onClick={onLogout}
                className="p-2 hover:bg-dark-700 rounded transition-colors text-dark-400 hover:text-dark-200"
                title="Sair"
              >
                <LogOut size={18} />
              </button>
            )}
          </div>
        </div>
      </div>
        </header>

    {profileOpen && user && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">

    <div className="w-full max-w-md bg-dark-800 border border-dark-700 rounded-2xl p-6 shadow-2xl relative">

      <button
        onClick={() => setProfileOpen(false)}
        className="absolute top-4 right-4 text-dark-400 hover:text-white transition-all"
      >
        ✕
      </button>

      <div className="flex flex-col items-center text-center">

        <img
          src={
  user?.photoURL
  || 'https://ui-avatars.com/api/?name=User&background=7C3AED&color=fff'
}
          alt="User"
          className="w-24 h-24 rounded-full object-cover border-4 border-purple-600 shadow-lg mb-4"
        />

        <h2 className="text-2xl font-bold text-white">
          {user.displayName || 'Usuário'}
        </h2>

        <p className="text-dark-300 mt-1">
          {user.email}
        </p>

        <div className="w-full mt-6 space-y-3">

          <div className="bg-dark-900 border border-dark-700 rounded-xl p-4 text-left">
            <span className="text-dark-400 text-sm">
              {t.userId}
            </span>

            <p className="text-white text-sm break-all mt-1">
              {user.uid}
            </p>
          </div>

          <div className="bg-dark-900 border border-dark-700 rounded-xl p-4 text-left">
            <span className="text-dark-400 text-sm">
              {t.loginMethod}
            </span>

            <p className="text-white text-sm mt-1">
              {user.providerData[0]?.providerId === 'google.com'
                ? 'Google'
                : 'Email e Senha'}
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
)}
    
{settingsOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">

    <div className="w-full max-w-md bg-dark-800 border border-dark-700 rounded-2xl p-6 shadow-2xl relative">

      <button
        onClick={() => setSettingsOpen(false)}
        className="absolute top-4 right-4 text-dark-400 hover:text-white transition-all"
      >
        ✕
      </button>

      <h2 className="text-2xl font-bold text-white mb-6">
        {t.settings}
      </h2>

      <div className="space-y-5">

        <div className="flex items-center justify-between bg-dark-900 border border-dark-700 rounded-xl p-4">

          <div>
  <h3 className="text-white font-medium">
    {t.sensitive}
  </h3>

  <p className="text-dark-400 text-sm mt-1">
    {t.sensitiveDescription}
  </p>
</div>

          <button
  onClick={toggleSensitiveContent}
  className={`w-12 h-7 rounded-full relative transition-all ${
    hideSensitive
      ? 'bg-purple-600'
      : 'bg-dark-600'
  }`}
>
            <div
  className={`absolute top-1 w-5 h-5 bg-white rounded-full transition-all ${
    hideSensitive
      ? 'right-1'
      : 'left-1'
  }`}
/>
          </button>

        </div>

        <div className="bg-dark-900 border border-dark-700 rounded-xl p-4">

          <h3 className="text-white font-medium mb-3">
            {t.language}
          </h3>

          <select
  value={language}
  onChange={handleLanguageChange}
  className="w-full h-12 px-4 rounded-xl bg-dark-800 border border-dark-700 text-white outline-none"
>
  <option value="pt">Português</option>
  <option value="en">English</option>
  <option value="es">Español</option>
</select>

        </div>

      </div>
    </div>
  </div>
)}
  </>
);
};

export default Header;
